function monthRange(start, end, value) {
  const out = {}
  const startDate = new Date(`${start}-01T00:00:00`)
  const endDate = new Date(`${end}-01T00:00:00`)
  const d = new Date(startDate)
  while (d <= endDate) {
    const k = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
    out[k] = value
    d.setMonth(d.getMonth() + 1)
  }
  return out
}

function mergeRanges(ranges) {
  return ranges.reduce((acc, r) => Object.assign(acc, monthRange(r.start, r.end, r.value)), {})
}

export const TABLA_TOPES = mergeRanges([
  { start: '1994-07', end: '2002-02', value: 4800 },
  { start: '2002-03', end: '2006-09', value: 6000 },
  { start: '2006-10', end: '2007-08', value: 7200 },
  { start: '2007-09', end: '2008-02', value: 7800 },
  { start: '2008-03', end: '2008-08', value: 8400 },
  { start: '2008-09', end: '2009-02', value: 9000 },
  { start: '2009-03', end: '2009-08', value: 9600 },
  { start: '2009-09', end: '2010-02', value: 10800 },
  { start: '2010-03', end: '2010-08', value: 12000 },
  { start: '2010-09', end: '2011-02', value: 14000 },
  { start: '2011-03', end: '2011-08', value: 16200 },
  { start: '2011-09', end: '2012-02', value: 19500 },
  { start: '2012-03', end: '2012-08', value: 22800 },
  { start: '2012-09', end: '2013-02', value: 25700 },
  { start: '2013-03', end: '2013-08', value: 28700 },
  { start: '2013-09', end: '2014-02', value: 32300 },
  { start: '2014-03', end: '2014-08', value: 36000 },
  { start: '2014-09', end: '2015-02', value: 42000 },
  { start: '2015-03', end: '2015-08', value: 48000 },
  { start: '2015-09', end: '2016-02', value: 56000 },
  { start: '2016-03', end: '2016-08', value: 64000 },
  { start: '2016-09', end: '2017-02', value: 72000 },
  { start: '2017-03', end: '2017-08', value: 81000 },
  { start: '2017-09', end: '2018-02', value: 94000 },
  { start: '2018-03', end: '2018-08', value: 108000 },
  { start: '2018-09', end: '2019-02', value: 126000 },
  { start: '2019-03', end: '2019-08', value: 151000 },
  { start: '2019-09', end: '2020-02', value: 182000 },
  { start: '2020-03', end: '2020-08', value: 221000 },
  { start: '2020-09', end: '2021-02', value: 267000 },
  { start: '2021-03', end: '2021-08', value: 322000 },
  { start: '2021-09', end: '2022-02', value: 389000 },
  { start: '2022-03', end: '2022-08', value: 470000 },
  { start: '2022-09', end: '2023-02', value: 568000 },
  { start: '2023-03', end: '2023-08', value: 690000 },
  { start: '2023-09', end: '2024-02', value: 836000 },
  { start: '2024-03', end: '2024-08', value: 1012000 },
  { start: '2024-09', end: '2025-02', value: 1225000 },
  { start: '2025-03', end: '2025-08', value: 1482000 },
  { start: '2025-09', end: '2026-02', value: 1794000 },
  { start: '2026-03', end: '2026-05', value: 2130000 },
])

const RENTAS_BASE = {
  A: 1,
  B: 1.27,
  C: 1.55,
  D: 1.9,
  E: 2.35,
  F: 2.95,
  G: 3.7,
  H: 4.6,
  I: 5.7,
  J: 7,
}

function buildRentas(start, end, base) {
  const out = {}
  const startDate = new Date(`${start}-01T00:00:00`)
  const endDate = new Date(`${end}-01T00:00:00`)
  const d = new Date(startDate)
  while (d <= endDate) {
    const k = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
    out[k] = Object.fromEntries(Object.entries(RENTAS_BASE).map(([cat, mult]) => [cat, Math.round(base * mult)]))
    d.setMonth(d.getMonth() + 1)
  }
  return out
}

export const RENTAS_AUTONOMOS = {
  ...buildRentas('1994-07', '2001-12', 700),
  ...buildRentas('2002-01', '2009-12', 1400),
  ...buildRentas('2010-01', '2015-12', 4200),
  ...buildRentas('2016-01', '2019-12', 12000),
  ...buildRentas('2020-01', '2022-12', 42000),
  ...buildRentas('2023-01', '2024-12', 135000),
  ...buildRentas('2025-01', '2026-05', 330000),
}

export const INDICES_MOVILIDAD = {
  ISBIC: {
    fuente: 'Serie sintetica para etapa de integracion',
    serie: {
      '2023-01': 1.0,
      '2024-01': 1.82,
      '2025-01': 2.96,
      '2026-05': 4.21,
    },
  },
  RIPTE: {
    fuente: 'Serie sintetica para etapa de integracion',
    serie: {
      '2023-01': 1.0,
      '2024-01': 1.71,
      '2025-01': 2.68,
      '2026-05': 3.84,
    },
  },
  IPC: {
    fuente: 'Serie sintetica para etapa de integracion',
    serie: {
      '2023-01': 1.0,
      '2024-01': 2.37,
      '2025-01': 4.94,
      '2026-05': 7.85,
    },
  },
}

export const MONEDA_HISTORICA = {
  australesAHiperpesos: 1000,
  hiperpesosAPesosLey23928: 10000,
}
